export default {
        name: 'VueAllInitMixin',
        created: function () {
            this.VueAllInit();
        },
        methods: {
            VueAllInit: function () {
                doHeaderSlider();
                hasScrolled();
                var options = {
                    fileExt: false,
                    captionType: 'data',
                    captionsData: "caption"
                };
                var lightbox = jQuery('.acfgallery a').simpleLightbox(options);
                //var commentgallery = $('.commentgallery a').simpleLightbox();
            }

        }
    }
